import request from '@/utils/request'

const END_POINT = '/dbservice/api/v1/stocks'
const EDD_POINT_BY_AF = `${END_POINT}/affiliate`

const api = {}

api.getStocksByAfId = (id, subs) => request.post(`${EDD_POINT_BY_AF}/${id}`, { subs })
api.getStocksByPublicationId = (id) => request.get(`${END_POINT}/${id}`)

export default api
